// The API lives on a different origin than this app. Apache pins
// Access-Control-Allow-Origin to "*" and never sends Allow-Credentials, so a
// cookie session is impossible without editing a vhost on a shared server.
// A Bearer header is not a CORS credential, so it works against "*" as-is.
export const API_BASE = 'https://link.asakreasi.com';

const TOKEN_KEY = 'auth_token';
const EMAIL_KEY = 'auth_email';

// localStorage throws in private windows with site data blocked, so every
// access is guarded — a storage failure must not blank the whole page.
const read = (key) => {
    try {
        return localStorage.getItem(key);
    } catch {
        return null;
    }
};

export const getToken = () => read(TOKEN_KEY);
export const getEmail = () => read(EMAIL_KEY);

export const setSession = (token, email) => {
    try {
        localStorage.setItem(TOKEN_KEY, token);
        localStorage.setItem(EMAIL_KEY, email);
    } catch {
        /* session lasts only this page load */
    }
};

export const clearSession = () => {
    try {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(EMAIL_KEY);
    } catch {
        /* nothing to clear */
    }
};

// Throws Error(message) on any non-2xx so callers keep the try/catch shape the
// create form already used.
export async function apiFetch(path, options = {}) {
    const token = getToken();

    const response = await fetch(`${API_BASE}${path}`, {
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
            ...options.headers,
        },
    });

    if (response.status === 401) {
        // A 401 means the session is gone, so there is no in-page state worth
        // preserving — a hard redirect beats threading auth state everywhere.
        clearSession();
        if (window.location.pathname !== '/login') window.location.replace('/login');
        throw new Error('Your session has expired. Please sign in again.');
    }

    if (response.status === 204) return null;

    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.error || 'Something went wrong');
    return data;
}
